import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noUrlValidator(): ValidatorFn {
  const urlRegex = /(http(s)?:\/\/)|(www\.)|(\.[a-z]{2,4}\/)/i;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value && typeof value === 'string' && urlRegex.test(value)) {
      return { 'hasUrl': true };
    }
    
    return null;
  };
}